module.exports = __webpack_public_path__ + "img/point_transfer.ea1e36bb.svg";